import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    link: {
        textDecoration: 'none',
        '&:hover, &:focus': {
            background: '#F7F9FA'
        },
        borderLeft: '4px solid #F7F9FA',
        fontWeight: 'bold'
    },
    externalLink: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textDecoration: 'none'
    },
    linkActive: {
        borderLeft: '4px solid #5EC8FF',
        color: '#0253CC'
    },
    linkNested: {
        paddingLeft: 0,
        '&:hover, &:focus': {
            background: '#F7F9FA'
        }
    },
    linkIcon: {
        marginRight: theme.spacing(1),
        color: `${theme.palette.text.secondary}99`,
        transition: theme.transitions.create('color'),
        width: 24,
        display: 'flex',
        justifyContent: 'center'
    },
    linkIconActive: {
        color: theme.palette.primary.main
    },
    linkText: {
        padding: 0,
        color: `${theme.palette.text.secondary}CC`,
        transition: theme.transitions.create(['opacity', 'color']),
        fontSize: theme.palette.textSizeLarge,
        fontWeight: 'bold'
    },
    linkTextActive: {
        color: '#0253CC'
    },

    linkTextWrap: {
        whiteSpace: 'initial',
    },
    linkTextHidden: {
        opacity: 0
    },
    nestedList: {
        paddingLeft: theme.spacing(2) + 30
    },
    sectionTitle: {
        marginLeft: theme.spacing(4.5),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(4),
        height: 1,
        backgroundColor: '#D8D8D880'
    }
}));
